"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractParserWithWordBoundary_1 = require("./AbstractParserWithWordBoundary");

var PATTERN = new RegExp("([0-9]{4})\\-([0-9]{1,2})\\-([0-9]{1,2})" + "(?:T" + "([0-9]{1,2}):([0-9]{1,2})" + "(?:" + ":([0-9]{1,2})(?:\\.(\\d{1,4}))?" + ")?" + "(?:" + "Z|([+-]\\d{2}):?(\\d{2})?" + ")?" + ")?" + "(?=\\W|$)", "i");
var YEAR_NUMBER_GROUP = 1;
var MONTH_NUMBER_GROUP = 2;
var DATE_NUMBER_GROUP = 3;
var HOUR_NUMBER_GROUP = 4;
var MINUTE_NUMBER_GROUP = 5;
var SECOND_NUMBER_GROUP = 6;
var MILLISECOND_NUMBER_GROUP = 7;
var TZD_HOUR_OFFSET_GROUP = 8;
var TZD_MINUTE_OFFSET_GROUP = 9;

var ISOFormatParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(ISOFormatParser, _AbstractParserWithWo);

  var _super = _createSuper(ISOFormatParser);

  function ISOFormatParser() {
    _classCallCheck(this, ISOFormatParser);

    return _super.apply(this, arguments);
  }

  _createClass(ISOFormatParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return PATTERN;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var components = {};
      components["year"] = parseInt(match[YEAR_NUMBER_GROUP]);
      components["month"] = parseInt(match[MONTH_NUMBER_GROUP]);
      components["day"] = parseInt(match[DATE_NUMBER_GROUP]);

      if (match[HOUR_NUMBER_GROUP] != null) {
        components["hour"] = parseInt(match[HOUR_NUMBER_GROUP]);
        components["minute"] = parseInt(match[MINUTE_NUMBER_GROUP]);

        if (match[SECOND_NUMBER_GROUP] != null) {
          components["second"] = parseInt(match[SECOND_NUMBER_GROUP]);
        }

        if (match[MILLISECOND_NUMBER_GROUP] != null) {
          components["millisecond"] = parseInt(match[MILLISECOND_NUMBER_GROUP]);
        }

        if (match[TZD_HOUR_OFFSET_GROUP] == null) {
          components["timezoneOffset"] = 0;
        } else {
          var hourOffset = parseInt(match[TZD_HOUR_OFFSET_GROUP]);
          var minuteOffset = 0;

          if (match[TZD_MINUTE_OFFSET_GROUP] != null) {
            minuteOffset = parseInt(match[TZD_MINUTE_OFFSET_GROUP]);
          }

          var offset = hourOffset * 60;

          if (offset < 0) {
            offset -= minuteOffset;
          } else {
            offset += minuteOffset;
          }

          components["timezoneOffset"] = offset;
        }
      }

      return components;
    }
  }]);

  return ISOFormatParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = ISOFormatParser;